import React from 'react';

const CONTACT_EMAIL = 'office@communityltd.co.il';

const sections = [
  {
    title: 'מי אנחנו',
    body: [
      'אפליקציית "MABAT – כל הפרויקט במבט אחד" (להלן: "האפליקציה") מופעלת על ידי קומיוניטי בונים קהילות בע"מ, ח.פ. 51-521641-4, תל אביב-יפו (להלן: "החברה", "אנחנו").',
      'האפליקציה משמשת דיירים בפרויקטים של התחדשות עירונית ואת צוות הניהול של הפרויקט, ומאפשרת לעקוב אחר התקדמות הפרויקט, לקבל הודעות ומסמכים, לאשר הגעה לכנסים וליצור קשר עם צוות הפרויקט.',
    ],
  },
  {
    title: 'איזה מידע אנחנו אוספים',
    list: [
      'פרטי זיהוי וקשר: שם, מספר טלפון, כתובת אימייל (אם נמסרה) ותעודת זהות, כפי שנמסרו לצורך ניהול הפרויקט.',
      'פרטי הדירה והבניין: כתובת, מספר דירה, אחוז החזקה, שטחים ופרטים טכניים הקשורים לדירה הקיימת ולדירה החדשה.',
      'פעילות באפליקציה: כניסות, אישורי הגעה לכנסים, הודעות ששלחת לצוות הפרויקט, ושאלות ששאלת את העוזר הדיגיטלי (AI) ותשובותיו.',
      'מסמכים וקבצים: קבצים שהועלו עבורך או על ידך, כגון מסמכי הפרויקט ותוכניות דירה.',
      'מידע טכני בסיסי הנדרש להפעלת השירות, כגון סוג הדפדפן והמכשיר.',
    ],
  },
  {
    title: 'למה אנחנו משתמשים במידע',
    list: [
      'זיהוי והתחברות לאפליקציה באמצעות קוד אימות שנשלח ב-SMS.',
      'מתן שירותי הפורטל: הצגת מצב הפרויקט, הודעות, מסמכים ופרטי הדירה.',
      'שליחת הזמנות לכנסים, תזכורות והודעות הקשורות לפרויקט.',
      'מענה לפניות ולשאלות, כולל באמצעות עוזר דיגיטלי.',
      'תפעול, אבטחה ושיפור השירות.',
    ],
  },
  {
    title: 'עם מי אנחנו משתפים מידע',
    body: [
      'איננו מוכרים מידע אישי. אנו משתמשים בספקי שירות הנדרשים להפעלת האפליקציה, והם מקבלים את המידע במידה הנדרשת לצורך מתן השירות בלבד:',
    ],
    list: [
      'שירותי אחסון ושרתים (Amazon Web Services) לאחסון הנתונים והקבצים.',
      'ספק שליחת הודעות SMS לשליחת קודי אימות, הזמנות לכנסים ותזכורות.',
      'ספק בינה מלאכותית (Anthropic) לעיבוד שאלות שנשאלות בעוזר הדיגיטלי. השאלה והמידע הנדרש למענה עליה נשלחים לעיבוד.',
      'צוות הפרויקט: עובדי החברה ומנהלי הפרויקט הרלוונטיים לבניין שלך.',
    ],
    after: 'ייתכן שנחשוף מידע גם אם נידרש לכך על פי דין או צו של רשות מוסמכת.',
  },
  {
    title: 'אבטחת מידע ושמירת נתונים',
    body: [
      'אנו נוקטים אמצעי אבטחה סבירים להגנה על המידע, כולל הצפנת התקשורת (HTTPS) והגבלת הגישה למידע לגורמים מורשים. עם זאת, אין שיטת אבטחה שהיא מושלמת.',
      'אנו שומרים את המידע כל עוד הוא נחוץ לניהול הפרויקט ולמתן השירות, או כנדרש על פי דין.',
    ],
  },
  {
    title: 'הזכויות שלך',
    body: [
      'בהתאם לחוק הגנת הפרטיות, התשמ"א-1981, אתה רשאי לבקש לעיין במידע האישי שלך, לתקן אותו, או לבקש את מחיקתו. לבקשות ניתן לפנות אלינו בכתובת המופיעה בהמשך.',
    ],
  },
  {
    id: 'delete',
    title: 'מחיקת חשבון ונתונים',
    body: [
      'כדי לבקש מחיקה של הגישה שלך לאפליקציה ושל המידע האישי שלך, שלח/י אימייל אלינו לכתובת:',
    ],
    contact: true,
    after: 'בבקשה יש לציין את שמך המלא, מספר הטלפון שבו אתה מתחבר ושם הפרויקט. נאמת את זהותך ונטפל בבקשה בהקדם. מידע שאנו חייבים לשמור על פי דין לא יימחק, ונמסור על כך הודעה.',
  },
  {
    title: 'ילדים',
    body: ['האפליקציה מיועדת לבעלי דירות ולדיירים בגירים, ואיננה מיועדת לילדים.'],
  },
  {
    title: 'שינויים במדיניות',
    body: ['ייתכן שנעדכן את המדיניות מעת לעת. הגרסה העדכנית תפורסם בעמוד זה, עם תאריך העדכון האחרון.'],
  },
  {
    title: 'יצירת קשר',
    body: ['לשאלות בנושא פרטיות או למימוש הזכויות שלך:'],
    contact: true,
  },
];

export default function PrivacyPolicy() {
  return (
    <div style={{ background: '#f4f7f8', minHeight: '100vh', direction: 'rtl', fontFamily: 'Heebo, Arial, sans-serif', color: '#1c3a40' }}>
      <div style={{ background: '#164a52', color: 'white', padding: '28px 20px', textAlign: 'center' }}>
        <h1 style={{ margin: 0, fontSize: '1.6rem' }}>מדיניות פרטיות</h1>
        <div style={{ marginTop: 6, opacity: 0.85 }}>MABAT – כל הפרויקט במבט אחד</div>
      </div>
      <div style={{ maxWidth: 780, margin: '0 auto', padding: '24px 18px 60px' }}>
        <p style={{ color: '#6b7f84', fontSize: '0.9rem' }}>עודכן לאחרונה: 5.10.2026</p>
        {sections.map(s => (
          <section key={s.title} id={s.id} style={{ background: 'white', borderRadius: 12, padding: '18px 20px', marginBottom: 14, boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
            <h2 style={{ margin: '0 0 10px', fontSize: '1.15rem', color: '#164a52' }}>{s.title}</h2>
            {s.body && s.body.map((p, i) => <p key={i} style={{ margin: '0 0 8px', lineHeight: 1.7 }}>{p}</p>)}
            {s.list && (
              <ul style={{ margin: '0 0 8px', paddingInlineStart: 22, lineHeight: 1.8 }}>
                {s.list.map((li, i) => <li key={i}>{li}</li>)}
              </ul>
            )}
            {s.contact && (
              <p style={{ margin: '0 0 8px' }}>
                <a href={`mailto:${CONTACT_EMAIL}`} style={{ color: '#1d4ed8', fontWeight: 700 }}>{CONTACT_EMAIL}</a>
              </p>
            )}
            {s.after && <p style={{ margin: 0, lineHeight: 1.7 }}>{s.after}</p>}
          </section>
        ))}
        <div style={{ textAlign: 'center', color: '#6b7f84', fontSize: '0.85rem', marginTop: 20 }}>
          קומיוניטי בונים קהילות בע"מ · ח.פ. 51-521641-4 · communityltd.co.il
        </div>
      </div>
    </div>
  );
}
